<template>
  <x-page title="确认订单" :loading="loading">
    <template v-if="!loading">
      <StationItem
        v-if="!is全是虚拟商品 && preOrderData.shipType === 1"
        :class="_.station"
        :item="selfPickupAddressInfo"
        :no-distance="true"
      />

      <!-- 收货地址 -->
      <div
        v-else-if="!is全是虚拟商品"
        v-track="{
          name: '确认订单-选择地址',
          id: 'a9541ce6-206f-42d1-9415-d7f2c8b9fac0',
        }"
        :class="_.address"
      >
        <x-card
          v-if="!address.id"
          :class="_.add"
          @click.native="handleChooseAddressClick"
        >
          <img :src="require('./images/地址.png')" :class="_.icon" />
          <div :class="_.text">请添加收货地址</div>
        </x-card>
        <x-card
          v-else
          :class="_.content"
          @click.native="handleChooseAddressClick"
        >
          <img :src="require('./images/已选择地址.png')" :class="_.icon" />
          <div :class="_.left">
            <div :class="_.hd">
              <div :class="_.user">{{ address.receiver }}</div>
              <div :class="_.phone">{{ address.phoneNo }}</div>
              <div v-if="address.defaultFlag" :class="_.tag">默认</div>
            </div>
            <div :class="_.bd">
              {{
                `${address.province}${address.city}${address.county}${address.street}${address.detail}`
              }}
            </div>
          </div>
          <van-icon name="arrow" :class="_.arrow" />
        </x-card>
      </div>

      <!-- 实名认证 -->
      <x-card
        v-if="preOrderData.showNeedRealNameAuth"
        :class="_.authentication"
      >
        <div>
          <div :class="_.title">
            {{ preOrderData.realNameStatusInfo.title }}
          </div>
          <div v-if="userInfo.authName" :class="_.jumpAuthenticationsRow">
            <div :class="_.leftContain">
              <img
                :src="require('./images/确认实名认证.png')"
                :class="_.img_icon"
              />
              将使用 {{ userInfo.authName }} 先生/女士的实名信息下单
            </div>
            <div
              :class="_.link"
              @click.stop="
                handelerealNameRules(preOrderData.realNameStatusInfo.url)
              "
            >
              {{ preOrderData.realNameStatusInfo.linkName }}
            </div>
          </div>
          <div v-else :class="_.jumpAuthentications">
            <div :class="_.leftContain">
              <img
                :src="require('./images/确认实名认证.png')"
                :class="_.img_icon"
              />
              您还未进行实名认证
            </div>
            <div :class="_.link" @click="gotoAuth">点击去实名</div>
          </div>
          <div v-if="preOrderData.realNameStatusInfo.tip" :class="_.tips">
            {{ preOrderData.realNameStatusInfo.tip }}
          </div>
        </div>
      </x-card>

      <!-- 商品列表 -->
      <x-card
        v-for="merchant in preOrderData.orderInfo"
        :key="merchant.merchantId"
        :class="_.merchant"
      >
        <div :class="[_.hd, _._hairlineBottom]">
          <img
            :src="merchant.merchantPic || require('./images/店铺.png')"
            :class="_.logo"
          />
          <div :class="_.name">{{ merchant.merchantName }}</div>
        </div>
        <div :class="_.bd">
          <div
            v-for="goods in merchant.commodityInfo"
            :key="goods.commodityId"
            :class="_.goods"
          >
            <van-image :src="goods.commodityPic" :class="_.cover" fit="cover" />
            <div :class="_.main">
              <div :class="_.top">
                <div :class="_.content">
                  <div :class="[_.name, _._ellipsis2]">
                    {{ goods.commodityName }}
                  </div>
                  <div :class="_.desc">{{ goods.skuDesc }}</div>
                </div>
                <div :class="_.info">
                  <div :class="_.price">￥{{ goods.unitPrice }}</div>
                  <div :class="_.amount">x{{ goods.count }}</div>
                </div>
              </div>
              <div v-if="goods.bonusText" :class="_.tips">
                交易完成可获得{{ goods.bonusText }}
              </div>
            </div>
          </div>
        </div>
        <div :class="_.ft">
          <div
            v-if="
              preOrderData.shipType !== 1 &&
              merchant.commodityInfo.every(goods => goods.commodityType !== 2)
            "
            :class="_.item"
          >
            <div :class="_.label">配送</div>
            <div :class="_.value">快递配送</div>
            <div :class="_.extra">
              {{
                !orderIdToPostFee[merchant.orderId]
                  ? '包邮'
                  : `￥${orderIdToPostFee[merchant.orderId]}`
              }}
            </div>
          </div>
          <div :class="_.item">
            <div :class="_.label">备注</div>
            <div :class="_.value">
              <input
                v-model="orderData[merchant.orderId].remark"
                v-fix-keyboard
                type="text"
                :class="_.input"
                placeholder="选填，给商家留言"
                maxlength="20"
                @blur="setRemark"
              />
            </div>
          </div>
        </div>
        <div :class="_.ex">
          <div :class="_.count">共 {{ merchant.totalQuantity }} 件</div>
          <div :class="_.label">小计</div>
          <div :class="_.unit">¥</div>
          <div :class="_.price">
            {{ merchant.totalAmount }}
          </div>
        </div>
      </x-card>

      <!-- 拼团玩法 -->
      <x-card v-if="is拼团下单" :class="_.groupBuying">
        <div :class="[_.hd, _._hairlineBottom]">
          <div :class="_.title">
            <img :src="require('./images/拼团.png')" :class="_.icon" />
            <div :class="_.text">拼团玩法</div>
          </div>
          <div :class="_.more" @click="handleGroupBuyingRuleClick">
            详细规则
            <x-icon name="arrow" :class="_.arrow" />
          </div>
        </div>
        <div :class="_.bd">
          <img
            :src="
              preOrderData.groupType === 'NORMAL'
                ? require('./images/拼团一阶玩法.png')
                : require('./images/拼团多阶玩法.png')
            "
            :class="_.image"
          />
        </div>
      </x-card>

      <!-- 概况 -->
      <x-card :class="_.brief">
        <div :class="_.item">
          <div :class="_.label">商品总额</div>
          <div :class="_.value">¥{{ preOrderData.orderAmount }}</div>
        </div>
        <div :class="_.item">
          <div :class="_.label">运费</div>
          <div :class="_.value">¥{{ postFee }}</div>
        </div>

        <!-- 优惠券 -->
        <div
          v-if="!is秒杀下单 && !is拼团下单 && !isExchange"
          v-track="{
            name: '确认订单-优惠券',
            id: 'ab985c22-d4f4-45f4-93af-fd0a71c89d26',
          }"
          :class="_.item"
        >
          <div :class="_.label">优惠券</div>
          <x-pick-coupon
            :key="
              isDcd
                ? preOrderData.orderInfo[0].commodityInfo[0].integralActivity
                    .count
                : 'coupon'
            "
            v-model="couponData"
            :params="pickCouponParams"
            :class="_.value"
          >
            <template #default="{ noCoupon, selectedCoupon }">
              <span
                :class="noCoupon || !selectedCoupon.couponId ? _.gray : _.red"
              >
                {{
                  noCoupon
                    ? '无可用优惠券'
                    : selectedCoupon.couponId
                    ? `-¥${selectedCoupon.discountedAmt}`
                    : '选择优惠券'
                }}
              </span>
              <van-icon name="arrow" :class="_.arrow" />
            </template>
          </x-pick-coupon>
        </div>

        <!-- 消费金补贴 -->
        <div
          v-if="
            !is秒杀下单 &&
            !is拼团下单 &&
            !isExchange &&
            preOrderData.supportPayType &&
            showPoints
          "
          v-track="{
            name: '确认订单-消费金补贴',
            id: 'ab985c22-d4f4-45f4-93af-fd0a71c89d26',
          }"
          :class="_.item"
        >
          <div :class="_.label">消费金补贴</div>
          <x-pick-paypoints
            key="points"
            v-model="pointsData"
            :params="pickPointsParams"
            :class="_.value"
          >
            <template #default="{ selectedPoints }">
              <span :class="!selectedPoints.integralCouponId ? _.gray : _.red">
                {{
                  selectedPoints.integralCouponId
                    ? `${selectedPoints.integralCouponName} -¥${selectedPoints.integralDiscountAmt}`
                    : '选择消费金'
                }}
              </span>
              <van-icon name="arrow" :class="_.arrow" />
            </template>
          </x-pick-paypoints>
        </div>

        <!-- 渠道积分 -->
        <x-channel-point-picker
          v-if="
            !is秒杀下单 &&
            !is拼团下单 &&
            !isDcd &&
            preOrderData.channelActivityItems.length
          "
          v-model="channelPointIndex"
          :class="_.item"
          :pre-order-data="preOrderData"
          @confirm="handleChannelPointConfirm"
        />

        <!-- 其他优惠项目 -->
        <div v-for="item in discountData" :key="item.name" :class="_.item">
          <div :class="_.label">{{ item.name }}</div>
          <div :class="_.value">
            <span :class="_.red"> -¥{{ item.amount }} </span>
          </div>
        </div>

        <!-- 多彩豆 -->
        <x-dcd-picker
          v-if="isDcd"
          ref="dcd"
          :pre-order-data="preOrderData"
          :class="_.item"
        />
      </x-card>

      <!-- 操作 -->
      <div :class="_.actions">
        <div v-if="preOrderData.showNeedRealNameAuth" :class="_.isReadBox">
          <van-checkbox
            v-model="readAndselected"
            :class="_.isRead"
            style="width: 100%"
            checked-color="#FF960A"
          >
            已阅读并同意
            <span
              style="color: #018ff0"
              @click.stop="
                handelerealNameRules(preOrderData.businessRuleInfo.url)
              "
              >{{ preOrderData.businessRuleInfo.title }}</span
            >
          </van-checkbox>
        </div>
        <div :class="_.ft">
          <div :class="_.amount">共{{ totalGoods }}件,</div>
          <div :class="_.total">合计:￥{{ showMoney }}</div>
          <div :class="_.grow" />
          <!-- <div
            v-if="preOrderData.supportPayType"
            v-track="{
              name: '消费金支付',
              id: 'clauqr34i0000txrl03ep8vr2',
            }"
            :class="[_.button, _.secondary]"
            @click="handlePointPayClick"
          >
            契税金支付
          </div> -->
          <div
            v-track="{
              name: '确认订单-立即支付',
              id: '334a0312-e334-4ab4-8bf9-51ca1c0138e1',
              content: goodsIds.join('|'),
            }"
            :class="_.button"
            @click="handlePayPrepare"
          >
            {{
              isExchange
                ? '立即兑换'
                : preOrderData.supportPayType
                ? '消费金支付'
                : '立即支付'
            }}
          </div>
        </div>
      </div>
      <div :class="_.placeholder" />
    </template>
    <van-dialog
      v-model="dialogShow"
      show-cancel-button
      :confirm-button-text="confirmButtonText"
      confirm-button-color="#16BBBF"
      :class="_.tipsDialog"
      @confirm="dialogConfirm"
    >
      <div :class="_.payInfoDialog">
        <template v-if="dialogType === 'auth'">
          <div :class="_.payInfoDialogTitle">
            <div>提醒</div>
          </div>
          <div :class="_.payInfoDialogBody">
            当前商品需要实名购买，您需要完成实名认证后才能下单。
          </div>
        </template>

        <template v-else>
          <div :class="_.content">
            {{ preOrderData.businessRuleInfo.tipHead }}<br />
            {{ preOrderData.businessRuleInfo.tipContent }}
            <br />
            <span
              style="color: #018ff0"
              @click.stop="
                handelerealNameRules(preOrderData.businessRuleInfo.url)
              "
            >
              已阅读{{ preOrderData.businessRuleInfo.title }}
            </span>
          </div>
        </template>
      </div>
    </van-dialog>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { AddressBridge } from '@/views/address/bridge'
  import {
    apiActivityVirtualActivityFindUserIntegralCoupon,
    apiGroupBuyingTradeCalcPostFee,
    apiGroupBuyingTradePreOrder,
    apiGroupBuyingTradeTradeOrder,
    apiOrderExchangeGoodsCalcPostFee,
    apiOrderExchangeGoodsExchangeGoodsPreOrder,
    apiOrderExchangeGoodsExchangeGoodsTrade,
    apiOrderOrderGetUserInfo,
    apiTradeGeneralActCouponTradeIntegralJoinTrade,
    apiTradeGeneralTradeCalcPostFee,
    apiTradeGeneralTradePreOrder,
    apiTradeGeneralTradeTradeOrder,
    apiTradeSecKillTradeSeckillCalcPostFee,
    apiTradeSecKillTradeSeckillConfirmResult,
    apiTradeSecKillTradeSeckillTradeOrder,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  // import { Dialog } from 'vant'
  import StationItem from '@/views/station/components/item.vue'
  import { flatten, sumBy, values, wait } from 'vtils'
  import {
    getManyGoodsBonus,
    loopUntil,
    mapQuery,
    prepareData,
    requestPayment,
    showDialog,
    showSafeKeyboard,
    submit,
    Track,
  } from '@/utils'
  import { globalModel } from '@/model'
  import { handleGoodsError } from '@/views/goods/exports'
  import { mall } from '@/mall_jssdk'
  import { navigateBack, redirectTo, router } from '@/router'

  import { onPageVisibilityChange } from '@/utils'

  const handleGoodsOrderError = handleGoodsError({
    商品下架: () => navigateBack(),
    活动结束: () => navigateBack(),
    活动不能参与: () => navigateBack(),
  })

  export default Vue.extend({
    components: {
      StationItem,
    },

    mixins: [
      globalModel.mixin,
      mapQuery({
        type: {
          key: 'type',
        },
        supportIntegral: {
          key: 'supportIntegral',
        },
        _preOrderData: {
          key: 'data',
          json: true,
        },
        _preOrderRequestData: {
          key: 'preOrderRequestData',
          json: true,
        },
        _preOrderRequestData1: {
          key: 'preOrderRequestData1',
          json: true,
        },
        selfPickupAddressInfo: {
          key: 'selfPickupAddressInfo',
          json: true,
        },
      }),
      Track.provideMark(() => ({
        page: '确认订单',
      })),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,
      readAndselected: false,
      dialogShow: false,
      dialogType: 'auth',
      confirmButtonText: '同意',

      // 收货地址
      address: {},

      // 下单数据
      orderData: {},

      // 优惠券数据
      couponData: {},

      // 消费金数据
      pointsData: {},

      // 邮费
      postFee: 0,

      // 订单 ID 的邮费
      orderIdToPostFee: {},

      // 最新的预下单数据
      lastPreOrderData: {},

      // 折扣数据
      discountData: [],

      // 渠道积分索引
      channelPointIndex: null,

      // 渠道积分抵扣
      channelPointDiscount: 0,
      // 账户信息
      userInfo: {},
      //显示消费金补贴
      showPoints: false,
      //商家备注
      remark: '',
    }),

    computed: {
      // 是否拼团下单
      is拼团下单() {
        return this.type === 'groupBuying'
      },
      // 是否秒杀下单
      is秒杀下单() {
        return this.type === 'seckill'
      },
      isExchange() {
        return this.$route.query.sourceType === 'exchange'
      },

      // 是否多彩豆下单
      isDcd() {
        return this.type === 'dcd'
      },
      // 预下单数据
      preOrderData() {
        return this.lastPreOrderData && this.lastPreOrderData.preOrderId
          ? this.lastPreOrderData
          : this._preOrderData
      },
      // 预下单请求数据
      preOrderRequestData() {
        return this._preOrderRequestData
      },
      // 预下单请求数据
      preOrderRequestData1() {
        return this._preOrderRequestData1
      },
      // 商品 ID 列表
      goodsIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(...merchant.commodityInfo.map(goods => goods.commodityId))
          return res
        }, [])
      },

      // 商品名称列表
      goodsNames() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(...merchant.commodityInfo.map(goods => goods.commodityName))
          return res
        }, [])
      },
      // 商品资源 ID 列表（用于查询优惠券）
      goodsResourceIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(
            ...merchant.commodityInfo.map(goods =>
              JSON.stringify({
                id: goods.resourceId,
                name: goods.commodityName,
                price: goods.unitPrice,
                count: goods.count,
                totalAmt: mall.calculator.sub(
                  goods.totalPrice,
                  goods.discountActivityAmount,
                  this.dcdDiscountAmount,
                ),
                superimposeDiscountType: this.discountData[0]?.type || null,
                categoryId: goods.categoryId,
              }),
            ),
          )
          return res
        }, [])
      },
      // 选择优惠券的参数
      pickCouponParams() {
        return {
          goodsIdList: this.goodsResourceIds,
          amt: this.preOrderData.orderAmount,
          discountedAmt: mall.calculator.add(
            ...this.discountData.map(item => item.amount),
          ),
          businessType: this.preOrderData.businessType,
          unitOrgCode: this.preOrderData.unitOrgCode,
        }
      },
      // 选择消费金的参数
      pickPointsParams() {
        return {
          orderDiscountAmt: this.actualMoney,
          merchantId: this.preOrderData.unitOrgCode[0],
        }
      },

      // 商品数量
      totalGoods() {
        return sumBy(
          this.preOrderData.orderInfo,
          merchant => merchant.totalQuantity,
        )
      },
      // 多彩豆抵扣金额
      dcdDiscountAmount() {
        if (!this.isDcd) return 0
        const dcdActivity = {
          count:
            this.preOrderData.orderInfo[0].commodityInfo[0].integralActivity
              .initLimitCount,
          ...this.preOrderData.orderInfo[0].commodityInfo[0].integralActivity,
        }
        return mall.calculator.mul(
          dcdActivity.count,
          dcdActivity.discountAmount,
        )
      },
      // 实付金额
      actualMoney() {
        return mall.calculator.add(
          _ =>
            _.sub(
              // 订单金额
              this.preOrderData.orderAmount,
              // 减去折扣金额
              _ => _.add(...this.discountData.map(item => item.amount)),
              // 减去优惠券金额
              this.is秒杀下单 || this.is拼团下单
                ? 0
                : this.couponData.discountedAmt || 0,
              // 减去渠道积分抵扣金额
              this.channelPointDiscount,
              // 减去多彩豆优惠
              this.dcdDiscountAmount,
            ),
          // 加上邮费
          this.postFee,
        )
      },
      showMoney() {
        return mall.calculator.sub(
          this.actualMoney,
          this.pointsData.integralDiscountAmt || 0,
        )
      },

      is全是虚拟商品() {
        return (
          this.preOrderData &&
          this.preOrderData.preOrderContentType === 'VIRTUAL'
        )
      },
    },

    watch: {
      // 地址改变重新预下单
      address: {
        immediate: true,
        handler() {
          if (globalModel.state.isSeckill) {
            globalModel.update({
              isSeckill: false,
            })
            return
          }
          this.doPreOrder()
        },
      },
      // 计算订单提交数据
      preOrderData: {
        immediate: true,
        handler(preOrderData) {
          this.orderData = preOrderData.orderInfo.reduce((res, merchant) => {
            res[merchant.orderId] = {
              orderId: merchant.orderId,
              remark: this.remark,
            }
            return res
          }, {})
          this.discountData = preOrderData.discountItems || []
        },
      },
      // 优惠券不能与渠道积分共存
      couponData: {
        immediate: true,
        handler() {
          if (this.couponData.couponId) {
            this.channelPointIndex = null
            this.channelPointDiscount = 0
          }
        },
      },
      // 渠道积分不能与优惠券共存
      channelPointIndex: {
        immediate: true,
        handler() {
          if (this.channelPointIndex != null) {
            this.couponData = {}
          }
        },
      },
      actualMoney: {
        immediate: true,
        handler() {
          this.handleCouponChange()
        },
      },
    },

    async mounted() {
      await this.dataInit()

      const off = onPageVisibilityChange(async visible => {
        if (visible) {
          off()
          setTimeout(() => {
            this.dataInit()
          }, 1000)
        }
      })
    },

    methods: {
      setRemark(val) {
        this.remark = val.target.value
      },
      handleCouponChange() {
        setTimeout(() => {
          if (this.supportIntegral) {
            this.findUserIntegralCoupon()
          }
        }, 100)
      },
      async findUserIntegralCoupon() {
        const env = await dcb.getEnv()
        const data = await apiActivityVirtualActivityFindUserIntegralCoupon(
          {
            orderDiscountAmt: this.actualMoney,
            merchantId: this.preOrderData.unitOrgCode[0],
            paymentMethod: env.wechat ? 2 : 1,
          },
          {
            noErrorToast: true,
          },
        ).catch(() => [])

        this.pointsData = { ...data }
        this.showPoints = data.userIntegralCouponList.length > 0
      },
      // 准备数据
      async prepareData() {
        const { address } = await prepareData({
          address: AddressBridge.getDefaultAddress().then(
            res => res || {},
            () => ({}),
          ),
        })
        this.address = address
        this.loading = false
      },
      //  初始化
      async dataInit() {
        this.userInfo = await apiOrderOrderGetUserInfo()
        console.log('userInfo', this.userInfo)
        this.prepareData()
      },

      // 预下单
      async doPreOrder() {
        const isExchange = this.$route.query.sourceType === 'exchange'

        const { address } = this
        if (!address.id) {
          this.postFee = 0
          this.lastPreOrderData = this._preOrderData
        } else {
          await submit(async $ => {
            await $.start()
            this.lastPreOrderData = await (this.is拼团下单
              ? apiGroupBuyingTradePreOrder({
                  ...this.preOrderRequestData,
                  countyCode: this.address.districtCode,
                }).catch(handleGoodsOrderError)
              : this.is秒杀下单
              ? // 秒杀商品只预下单一次
                Promise.resolve(this._preOrderData)
              : isExchange
              ? apiOrderExchangeGoodsExchangeGoodsPreOrder({
                  ...this.preOrderRequestData1,
                })
              : apiTradeGeneralTradePreOrder({
                  ...this.preOrderRequestData,
                  countyCode: this.address.districtCode,
                  // 多彩豆
                  ...(this.isDcd
                    ? {
                        skuInfo: [
                          {
                            ...this.preOrderRequestData.skuInfo[0],
                            integralCount:
                              this.preOrderData.orderInfo[0].commodityInfo[0]
                                .integralActivity.count,
                          },
                        ],
                      }
                    : {}),
                })
            ).then(async res => {
              console.log('preOrderData', res, router.currentRoute.name)

              // if (
              //   res.supportPayType &&
              //   router.currentRoute.name === 'OrderPlace' &&
              //   !this.notFirst
              // ) {
              //   this.notFirst = true
              //   Dialog.alert({
              //     confirmButtonText: '同意并知晓',
              //     confirmButtonColor: '#45A168',
              //     className: 'subsidyPopup',
              //     message:
              //       '该商品参与适老化补贴活动，请您收到货后，拍摄清晰产品图并附带相机水印时间，将照片上传至订单评论区，且享受补贴资格的消费者需配合平台或商家不定期回访，请务必配合，对发现存在利用不正当手段挪用、骗取套取补贴资金的企业和个人(包括伪造、变造相关材料虚假交易、串通他人提供虚假信息等)，平台有权追回产品及补贴，并依法依规严肃处理，涉嫌犯罪的移送司法机关追究刑事责任。',
              //   })
              // }

              this.readAndselected = res.businessRuleInfo.selected

              const goodsList = flatten(
                res.orderInfo.map(orderItem => orderItem.commodityInfo),
              )
              const bonusMap = await getManyGoodsBonus(goodsList)
              for (const goods of goodsList) {
                goods.bonusText = bonusMap[goods.skuId] || ''
              }
              return res
            })
            await wait(0)
            const { orderInfo } = await (this.is拼团下单
              ? apiGroupBuyingTradeCalcPostFee
              : this.is秒杀下单
              ? apiTradeSecKillTradeSeckillCalcPostFee
              : this.isExchange
              ? apiOrderExchangeGoodsCalcPostFee
              : apiTradeGeneralTradeCalcPostFee)({
              preOrderId: this.preOrderData && this.preOrderData.preOrderId,
              consigneeAddress: {
                province: this.address.province,
                city: this.address.city,
                area: this.address.county,
                areaCode: this.address.districtCode,
                detail: this.address.detail,
                name: this.address.receiver,
                phoneNo: this.address.phoneNo,
              },
            })
            this.postFee = sumBy(orderInfo, item => item.postFee || 0)
            this.orderIdToPostFee = orderInfo.reduce((res, item) => {
              res[item.orderId] = item.postFee
              return res
            }, {})
          })
        }
      },

      // 点击选择地址
      async handleChooseAddressClick() {
        if (this.address.id) {
          AddressBridge.setChosenAddress(this.address)
        }

        const address = await AddressBridge.chooseAddress(
          this.goodsIds,
          this.address.id || '',
        )

        // if (address && address.id) {
        this.address = address || {}
        // }
      },

      // 点击拼团规则
      handleGroupBuyingRuleClick() {
        dcb.navigateTo({
          url: this.preOrderData.ruleUrl,
        })
      },
      // 跳转实名规则
      handelerealNameRules(url) {
        dcb.navigateTo({
          url,
        })
      },
      // 实名认证
      async gotoAuth() {
        const userInfo = await dcb.requestRealNameAuthentication()
        console.log('userInfo', userInfo)
        // this.
        await this.dataInit()
      },

      // 确认选择渠道积分
      handleChannelPointConfirm(item) {
        this.channelPointDiscount = +item.subAmount
      },

      async handlePayPrepare() {
        //  判断是否需要实名 是否实名 是否勾选已经阅读
        if (this.preOrderData.showNeedRealNameAuth) {
          if (this.userInfo.authName) {
            // 已经实名 判断是否勾选已经阅读
            if (this.readAndselected) {
              await this.handlePayClickBefore()
              // 已经勾选
            } else {
              this.dialogType = 'read'
              this.dialogShow = true
              this.confirmButtonText = '同意'
              // 未勾选
            }
          } else {
            //  未实名吊起实名
            this.dialogType = 'auth'
            this.dialogShow = true
            this.confirmButtonText = '去实名'
          }
        } else {
          await this.handlePayClickBefore()
        }
      },
      async dialogConfirm() {
        if (this.confirmButtonText === '同意') {
          await this.handlePayClickBefore()
        } else if (this.confirmButtonText === '去实名') {
          this.gotoAuth()
        }
      },
      async handlePayClickBefore() {
        if (this.isExchange) {
          this.handlePayClick()
        } else {
          if (globalModel.state.inLove) {
            this.handlePayClick()
            return
          }
          const res = await requestPayment(this.preOrderData)
          if (res.channel === 'dcb') {
            this.handlePayClick()
          } else if (res.channel === 'qsxfj') {
            this.handlePointPayClick()
          } else if (res.channel === 'yzf') {
            this.handlePayClick(res.payType)
          }
        }
      },

      // 点击立即支付按钮
      async handlePayClick(payType = globalModel.state.payType) {
        await submit(async $ => {
          if (
            !this.is全是虚拟商品 &&
            !this.address.id &&
            this.preOrderData.shipType !== 1
          ) {
            return $.fail('请先添加收货地址')
          }

          // 渠道积分抵扣
          let channelPointPassword = undefined
          if (this.channelPointIndex != null) {
            const channelPointItem =
              this.preOrderData.channelActivityItems[this.channelPointIndex]
            if (channelPointItem.needPassword) {
              channelPointPassword = await new Promise(resolve => {
                showSafeKeyboard({
                  type: channelPointItem.title,
                  config: channelPointItem.passwordKeyboard.keys,
                  onConfirm: resolve,
                })
              })
            }
            await new Promise((resolve, reject) => {
              showDialog({
                title: `提示`,
                message: `确认使用【${channelPointItem.title}${channelPointItem.balanceUnit}】抵扣支付？`,
                confirmText: '确认',
                cancelText: '取消',
                onConfirm: resolve,
                onCancel: reject,
              })
            })
          }

          // 多彩豆检查
          const dcdCheckRes = this.isDcd ? await this.$refs.dcd.check() : []
          let location = {}
          if (this.preOrderData.needLogLet) {
            location = await dcb.getLocationCoordinate({
              mustBeAuth: true,
            })
            if (!location.latitude) {
              return $.fail('请升级app版本到7.3.0以上并允许获取位置信息')
            }
          }

          await $.start()
          let payData = await (this.is拼团下单
            ? apiGroupBuyingTradeTradeOrder
            : this.is秒杀下单
            ? apiTradeSecKillTradeSeckillTradeOrder
            : this.isExchange
            ? apiOrderExchangeGoodsExchangeGoodsTrade
            : apiTradeGeneralTradeTradeOrder)({
            preOrderId: this.preOrderData.preOrderId,
            latitude: location?.latitude,
            longitude: location?.longitude,
            locationType: location?.coordType,
            consigneeName:
              this.preOrderData.shipType === 1
                ? this.selfPickupAddressInfo.contact
                : this.address.receiver,
            consigneeTel:
              this.preOrderData.shipType === 1
                ? this.selfPickupAddressInfo.contactTel
                : this.address.phoneNo,
            consigneeAddress:
              this.preOrderData.shipType === 1
                ? {
                    province: this.selfPickupAddressInfo.provinceName,
                    provinceCode: this.selfPickupAddressInfo.provinceCode,
                    city: this.selfPickupAddressInfo.cityName,
                    cityCode: this.selfPickupAddressInfo.cityCode,
                    area: this.selfPickupAddressInfo.countyName,
                    areaCode: this.selfPickupAddressInfo.countyCode,
                    detail: this.selfPickupAddressInfo.detailedAddress,
                    name: this.selfPickupAddressInfo.contact,
                    phoneNo: this.selfPickupAddressInfo.contactTel,
                  }
                : {
                    province: this.address.province,
                    provinceCode: this.address.provinceCode,
                    city: this.address.city,
                    cityCode: this.address.cityCode,
                    area: this.address.county,
                    areaCode: this.address.districtCode,
                    detail: `${this.address.street} ${this.address.detail}`,
                    name: this.address.receiver,
                    phoneNo: this.address.phoneNo,
                  },
            tradeOrderInfo: this.isDcd
              ? [
                  {
                    ...values(this.orderData)[0],
                    integralCount: dcdCheckRes[0]?.quantity || 0,
                  },
                ]
              : values(this.orderData),
            couponId: this.couponData.couponId,
            discountAmount: this.couponData.discountedAmt || 0,
            password: channelPointPassword,
            payType: payType,
            openId: globalModel.state.openid,
          }).catch(handleGoodsOrderError)
          this.$track.push({
            name: '提交订单',
            id: 'TiJiaoDinDan',
            extra: {
              order_id: payData.orderId,
              order_price: this.actualMoney,
              commodity_id: this.goodsIds.join(','),
              commodity_name: this.goodsNames.join(','),
              original_price: this.preOrderData.orderAmount,
              present_price: this.actualMoney,
              discount_price: this.preOrderData.orderAmount - this.actualMoney,
              submit_type: '立即支付',
            },
          })
          if (this.is秒杀下单) {
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
            )
            if (res.confirmState === 2) return $.fail(res.msg)
            payData = res.result

            globalModel.update({
              isSeckill: true,
            })
          }

          if (this.isExchange) {
            // Toast('兑换成功')
            redirectTo('OrderExchangeResult', {
              id: payData.orderId,
              sourceType: 0,
            })
            return
          }
          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: {
                ...payData,
                unsupportedTips:
                  this.channelPointIndex != null ? '账户余额不足' : undefined,
              },
            })

            await wait(1000)

            redirectTo(
              this.is拼团下单 ? 'GroupBuyingPaySuccess' : 'OrderPayResult',
              {
                // 拼单 ID
                id: payData.groupOrderId,
                orderNo: payData.mallOrders[0]?.orderNo,
              },
            )
          } catch {
            redirectTo(
              this.is拼团下单 ? 'GroupBuyingOrderIndex' : 'OrderIndex',
              {
                active: 1,
              },
            )
          }
        })
      },

      // 点击消费金支付按钮
      async handlePointPayClick() {
        await submit(async $ => {
          if (!this.is全是虚拟商品 && !this.address.id) {
            return $.fail('请先添加收货地址')
          }
          if (this.actualMoney === 0.01) {
            return $.fail('金额太低，不支持消费金方式')
          }
          await $.start()
          const payData = await apiTradeGeneralActCouponTradeIntegralJoinTrade({
            preOrderId: this.preOrderData.preOrderId,
            consigneeName: this.address.receiver,
            consigneeTel: this.address.phoneNo,
            consigneeAddress: {
              province: this.address.province,
              city: this.address.city,
              area: this.address.county,
              areaCode: this.address.districtCode,
              detail: `${this.address.street} ${this.address.detail}`,
              name: this.address.receiver,
              phoneNo: this.address.phoneNo,
            },
            tradeOrderInfo: values(this.orderData),
            couponId: this.couponData.couponId,
            discountAmount: this.couponData.discountedAmt || 0,
            payType: 12,
            openId: undefined,
          }).catch(handleGoodsOrderError)

          const payUrl = payData.targetUrl

          dcb.navigateTo({
            url: payUrl,
          })

          setTimeout(() => {
            redirectTo('OrderIndex')
          }, 60)
        })
      },
    },
  })
</script>

<style lang="scss" module>
  :global {
    .subsidyPopup {
      width: 270px;
      .van-dialog__message {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 18px;
        text-align: center;
        font-style: normal;
      }
    }
  }

  .station {
    margin: 12px;
  }

  .authentication {
    width: 327px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;

    .title {
      margin-bottom: 16px;
    }

    .jumpAuthentications {
      // height: 36px;
      // width: 100%;
      padding: 8px 12px;
      background: #f5f6f8;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .leftContain {
        color: #333333;
        display: flex;
        align-items: center;
      }

      .link {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #018ff0;
      }

      .img_icon {
        width: 16px;
        height: 16px;
        object-fit: cover;
        margin-right: 2px;
      }
    }

    .jumpAuthenticationsRow {
      padding: 8px 12px;
      background: #f5f6f8;
      border-radius: 4px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      .leftContain {
        color: #333333;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
      }

      .link {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #018ff0;
        margin-left: 18px;
      }

      .img_icon {
        width: 16px;
        height: 16px;
        object-fit: cover;
        margin-right: 2px;
      }
    }

    .tips {
      margin-top: 16px;
    }
  }

  .address {
    .add {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 19px;
        height: 19px;
      }

      .text {
        margin-left: 2px;
        font-size: 14px;
        color: #222222;
      }

      &:active {
        opacity: 0.8;
      }
    }

    .content {
      display: flex;
      align-items: center;

      .icon {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
      }

      .left {
        margin-left: 12px;
        flex-grow: 1;

        .hd {
          display: flex;
          align-items: center;

          .user {
            font-size: 14px;
            color: #222222;
            line-height: 20px;
          }

          .phone {
            margin-left: 8px;
            font-size: 14px;
            color: #888888;
            line-height: 20px;
          }

          .tag {
            margin-left: 8px;
            background: #fff2f1;
            border-radius: 1000px;
            font-size: 10px;
            color: #ff111c;
            padding: 2px 5px;
            line-height: 1;
          }
        }

        .bd {
          margin-top: 4px;
          font-size: 12px;
          color: #222222;
          line-height: 16px;
        }
      }

      .arrow {
        margin-left: 24px;
        flex-shrink: 0;
        font-size: 14px;
        color: #bebebe;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .merchant {
    .hd {
      display: flex;
      align-items: center;
      padding-bottom: 12px;

      .logo {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        user-select: none;
        -webkit-touch-callout: none;
      }

      .name {
        margin-left: 6px;
        font-size: 14px;
        color: #222222;
      }
    }

    .bd {
      .goods {
        margin-top: 14px;
        display: flex;

        .cover {
          flex-shrink: 0;
          width: 85px;
          height: 85px;
          border-radius: 8px;
          overflow: hidden;
        }

        .main {
          margin-left: 12px;
          flex-grow: 1;

          .top {
            display: flex;

            .content {
              flex-grow: 1;

              .name {
                font-size: 14px;
                color: #222222;
                line-height: 20px;
              }

              .desc {
                display: inline-block;
                margin-top: 4px;
                background: #f5f6f8;
                border-radius: 1000px;
                font-size: 10px;
                color: #888888;
                padding: 3px 6px;
              }
            }

            .info {
              margin-left: 20px;
              flex-shrink: 0;

              .price {
                font-size: 12px;
                color: #1d1d1c;
                text-align: right;
              }

              .amount {
                margin-top: 5px;
                font-size: 12px;
                color: #888888;
                text-align: right;
              }
            }
          }

          .tips {
            margin-top: 4px;
            font-size: 10px;
            color: #ff111c;
            line-height: 16px;
          }
        }
      }
    }

    .ft {
      .item {
        margin-top: 12px;
        display: flex;
        align-items: center;

        .label {
          flex-shrink: 0;
          width: 85px;
          text-align: right;
          font-size: 12px;
          color: #222222;
        }

        .value {
          margin-left: 12px;
          flex-grow: 1;
          font-size: 12px;
          color: #888888;

          .input {
            width: 100%;
            appearance: none;
            outline: none;
            box-shadow: none;
            border: none;
            border-radius: 0;

            &::placeholder {
              color: #bebebe;
            }
          }
        }

        .extra {
          flex-shrink: 0;
          font-size: 12px;
          color: #222222;
        }
      }
    }

    .ex {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .count {
        font-size: 12px;
        color: #989898;
        line-height: 18px;
      }

      .label {
        font-size: 12px;
        color: #222222;
        line-height: 18px;
        margin: 0 4px;
      }

      .unit {
        font-size: 10px;
        color: #ff111c;
        line-height: 16px;
        margin-right: 2px;
      }

      .price {
        font-size: 14px;
        color: #ff111c;
        line-height: 18px;
      }
    }
  }

  .groupBuying {
    .hd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 12px;

      .title {
        display: flex;
        align-items: center;

        .icon {
          width: 16px;
          height: 16px;
        }

        .text {
          margin-left: 8px;
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }
      }

      .more {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #989898;
        line-height: 17px;

        .arrow {
          font-size: 14px;
          color: #999;
        }

        &:active {
          opacity: 0.8;
        }
      }
    }

    .bd {
      padding-top: 12px;

      .image {
        width: 100%;
      }
    }
  }

  .brief {
    .item {
      display: flex;
      align-items: center;

      + .item {
        margin-top: 12px;
      }

      .label {
        flex-shrink: 0;
        font-size: 14px;
        color: #222222;
      }

      .value {
        flex-grow: 1;
        font-size: 14px;
        color: #222222;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        line-height: 1;

        .gray {
          color: #999;
        }

        .red {
          color: #ff111c;
        }

        .arrow {
          margin-left: 4px;
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
        }
      }
    }
  }

  .actions {
    position: fixed;
    // fix: iPhone 8 下不随滑动实时更新问题
    // https://stackoverflow.com/a/49264494
    transform: translate3d(0, 0, 0);
    left: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .isReadBox {
      padding-left: 24px;
      padding-top: 4px;
      padding-bottom: 12px;

      .isRead {
        width: 216px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;

        :global {
          // .van-radio__icon {
          //   display: flex;
          //   align-items: center;
          // }

          .van-checkbox__icon {
            font-size: 12px;
          }
        }
      }
    }

    .ft {
      background-color: white;
      display: flex;
      align-items: center;
      padding: 0px 12px 8px 12px;

      &:first-child {
        padding-top: 8px;
      }

      .amount {
        flex-shrink: 0;
        font-size: 14px;
        color: #888888;
      }

      .total {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: bold;
        color: #ff111c;
      }

      .grow {
        flex-grow: 1;
      }

      .button {
        margin-left: 8px;
        flex-shrink: 0;
        height: 34px;
        background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
        border-radius: 17px;
        padding: 0 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #ffffff;

        &:active {
          filter: contrast(0.9);
        }

        &.secondary {
          height: 34px;
          background: #ff960a;
          border-radius: 17px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
          font-size: 14px;
          color: #ffffff;

          + .button {
            margin-left: 0;
            height: 34px;
            background: #ff1c20;
            border-radius: 17px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 22px;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }

    + .placeholder {
      height: 120px;
    }
  }

  .tipsDialog {
    &:global(.van-dialog) {
      width: 270px;
    }
  }

  .payInfoDialog {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .payInfoDialogTitle {
      margin: 20px 21px 12px 21px;
      font-size: 17px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    .payInfoDialogBody {
      // display: flex;

      text-align: center;
      margin: 0 21px 20px 21px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }

    .content {
      margin-top: 20px;
      margin-bottom: 8px;
      width: 228px;
      height: 126px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
  }
</style>
